<script context="module">
    import { selectedItem, currentUser } from '../../store/store.js';
    import { analyzeLoading, createRedovisningExpertLoading, analyzeLoadingDone, createRedovisningExpertLoadingDone, fileUploadLoading, fileUploadLoadingDone } from '../../store/store.js';
    import Login from '../common/Login.svelte';
    import { handleAnalyzeBrf, handleCreateBrfExpert } from '../../utils/analyze.js';
    import { getFileNameId, fetchBrf } from '../../utils/utils.js';
    import Logotype from '../Logotype.svelte';
    import UploadFile from '../UploadFile.svelte';
    import { fade } from 'svelte/transition';

    async function handleAnalyzeInitialized(fileName, coreId) {
        analyzeLoadingDone.set(false);
        analyzeLoading.set(true);
        const processedFileName = getFileNameId(fileName);
        fileUploadLoading.set(false);
        fileUploadLoadingDone.set(true);
        createRedovisningExpertLoading.set(true);
        createRedovisningExpertLoadingDone.set(false);

        try {
            await Promise.all([
                handleAnalyzeBrf(processedFileName, coreId),
                handleCreateBrfExpert(processedFileName, coreId)
            ]);
            fetchBrf(coreId);
        } catch (error) {
            console.error('Error during analysis execution:', error.message);
            analyzeLoading.set(false);
        }
    }
</script>

{#if !$selectedItem?.analyzed && $selectedItem?.redovisning_file_name != null && $selectedItem?.redovisning_file_name !== ""}
<div class="upload-section box ready-container" transition:fade>
    {#if !($analyzeLoading || $createRedovisningExpertLoading)}
    <div class="ready-state centered-layout">
        <div class="bobot-container">
            <img src="/BoBot/BoBot-sleepy.svg" alt="BoBot Trött" class="bobot-tired animate__animated animate__shakeX" />
        </div>
        <div class="content-container">
            <h5>Lås upp insikterna om din BRF!</h5>
            <p class="description">
                En årsredovisning finns tillgänglig. Starta analysen för att:
            </p>
            <ul class="benefits-list">
                <li>Få en detaljerad ekonomisk översikt.</li>
                <li>Se föreningens nyckeltal och betyg.</li>
                <li>Aktivera BoBot för att ställa frågor.</li>
            </ul>
            <p class="duration-note">Analysen tar ca 30 sekunder. BoBot kan ta upp till 5 minuter att träna.</p>
            <button
                type="button"
                class="action-button"
                on:click={() => handleAnalyzeInitialized($selectedItem.redovisning_file_name, $selectedItem.core_id)}
            >
                Starta Analys <span class="button-arrow">&rarr;</span>
            </button>
        </div>
    </div>
    {:else}
    <div class="loading-container">
        <h3 class="loading-header">Analyserar årsredovisning...</h3>
        <div class="loading-items-wrapper">
            <div class="loading-item">
                <div class="question">
                    <Logotype scale={0.6}></Logotype> 
                </div>
                <div class="loading-text"> <span>Analyserar årsredovisning (ca 20 sek)...</span> </div>
            </div>
        </div>
    </div>
    {/if}
</div>
{#if $createRedovisningExpertLoading}
<div class="analyze-about-text">
  <div class="loading-container expert-loading-container">
    <h3 class="loading-header">Bakgrundsprocess: Skapar Expert</h3>
    <div class="loading-items-wrapper">
      <div class="loading-item">
          <div class="question">
              <Logotype scale={0.6}></Logotype> 
          </div>
          <div class="loading-text"> <span>Skapar expert (detta kan ta upp till 5 min)...</span> </div>
      </div>
    </div>
  </div>
</div>
{/if}
{/if}

{#if !$selectedItem?.analyzed && ($selectedItem?.redovisning_file_name == null || $selectedItem?.redovisning_file_name == "")}
<div class="upload-section box missing-container" transition:fade>
    <div class="missing-state">
        <div class="bobot-container small">
            <img src="/BoBot/BoBot-sleepy.svg" alt="BoBot Trött" class="bobot-tired" />
        </div>
        <div class="content-container">
            <h5>Årsredovisning krävs för analys</h5>
            <p class="description">
                Ladda upp föreningens årsredovisning (PDF) för att låsa upp analys, betyg och BoBots fulla potential.
            </p>
            {#if !$currentUser}
                <p class="login-prompt">Du behöver logga in för att ladda upp:</p>
                <Login />
            {:else}
                <div class="upload-integration-wrapper">
                    <UploadFile />
                </div>
            {/if}
        </div>
    </div>
</div>
{/if}

<style>
    .upload-section {
        background-color: #fff;
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        padding: 28px;
        margin-bottom: 20px;
        transition: box-shadow 0.3s ease;
    }
    .upload-section:hover {
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
    }

    h5 {
        font-size: 1.25rem;
        font-weight: 600;
        color: var(--box-title-color);
        margin-bottom: 15px;
        text-align: center;
    }

    p.description, p.duration-note, p.login-prompt {
        font-size: 0.95rem;
        color: #495057;
        line-height: 1.6;
        margin-bottom: 15px;
        text-align: center;
    }
    p.duration-note {
        font-size: 0.85rem;
        color: #6c757d;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .ready-container h5 {
        margin-bottom: 20px;
    }

    .ready-state.centered-layout {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 20px;
    }

    .bobot-container {
        flex-shrink: 0;
        padding: 15px;
        background-color: #f8f9fa;
        display: inline-block;
        border-radius: 10px;
        padding: 20px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        transition: transform 0.2s, box-shadow 0.2s;
        border: 1px solid #e9ecef;
    }
    .bobot-container.small {
        padding: 10px;
    }

    .ready-state .content-container {
        flex: 1;
        width: 100%;
        max-width: 600px;
    }

    .benefits-list {
        list-style: none;
        padding-left: 0;
        margin: 20px auto;
        display: inline-block;
        text-align: left;
    }

    .benefits-list li {
        position: relative;
        padding-left: 25px;
        margin-bottom: 10px;
        font-size: 0.95rem;
        color: #34495e;
    }

    .benefits-list li::before {
        content: '✓';
        position: absolute;
        left: 0;
        top: 1px;
        color: #28a745;
        font-weight: bold;
        font-size: 1rem;
    }

    .loading-container {
        background-color: #f8f9fa;
        border-radius: 10px;
        padding: 20px;
        border: 1px solid #e9ecef;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        margin-left: auto;
        margin-right: auto;
    }

    .loading-header {
        font-size: 1.1rem;
        font-weight: 600;
        color: var(--box-title-color);
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid #dee2e6;
        text-align: left;
    }

    .loading-items-wrapper {
        display: flex;
        flex-direction: column;
        gap: 15px;
    }

    .loading-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 15px;
        background-color: #fff;
        border-radius: 8px;
        padding: 15px;
        border: 1px solid #e0e0e0;
        min-height: 50px;
    }

    .loading-text {
        display: flex;
        align-items: center;
        font-size: 0.9rem;
        color: #495057;
        font-weight: 500;
        flex-grow: 1;
    }

    .missing-container h5 {
        color: #dc3545;
    }
    .missing-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 15px;
    }
    .missing-state .content-container {
        width: 100%;
        max-width: 550px;
    }
    .login-prompt {
        margin-top: 25px;
        margin-bottom: 10px;
        font-weight: 500;
        color: #343a40;
    }
    :global(.simple-login-container) {
        margin-top: 10px;
        width: 100%;
        max-width: 350px;
        margin-left: auto;
        margin-right: auto;
    }

    .upload-integration-wrapper {
        margin-top: 35px;
        border: 2px dashed #ced4da;
        border-radius: 8px;
        padding: 20px;
        background-color: #f8f9fa;
        transition: border-color 0.2s, background-color 0.2s;
    }
     .upload-integration-wrapper:hover {
        border-color: #adb5bd;
        background-color: #e9ecef;
    }
     .upload-integration-wrapper > :global(.upload-container) {
        margin: 0 !important;
        padding: 0 !important;
        border: none !important;
        box-shadow: none !important;
        background-color: transparent !important;
    }
     .upload-integration-wrapper :global(.drop-area) {
        padding: 10px !important;
    }
    .upload-integration-wrapper :global(.upload-instructions) {
        font-size: 0.9rem !important;
    }

    .bobot-tired {
        width: 100px;
        height: auto;
        padding-left: 20px;
        padding-right: 20px;
        display: block;
    }

    .bobot-tired:hover {
        animation: wobble 1s;
    }

</style>